import {
  FETCH_DELETELIST_REQUEST,
  FETCH_DELETELIST_SUCCESS,
  FETCH_DELETELIST_FAILURE,
} from "./reletedPartiesDeleteTypes";
import api from "../../utils/Api";
import axios from 'axios';

// Headers

export const fetchDeleteListRequest = () => {
  return {
    type: FETCH_DELETELIST_REQUEST,
  };
};

export const fetchDeleteListSuccess = (deleteList) => {
  return {
    type: FETCH_DELETELIST_SUCCESS,
    payload: deleteList,
  };
};

export const fetchDeleteListFailure = (error) => {
  return {
    type: FETCH_DELETELIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchDeleteList = (searchKey,sortBy,page) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchDeleteListRequest);
    try {
      const response = await api.get(
        "relatedparty/deletedlist/fetch?search_key="+searchKey+'&sort_by='+sortBy+"&page="+page,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const deleteList = response.data.data;
      dispatch(fetchDeleteListSuccess(deleteList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchDeleteListFailure(errorMsg));
    }
  };
};
